import { render } from "./component-kod-okved.vue?vue&type=template&id=e5573bcc"
import script from "./component-kod-okved.vue?vue&type=script&setup=true&lang=js"
export * from "./component-kod-okved.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-card/field-wrappers/component-kod-okved.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5573bcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5573bcc', __exports__)) {
    api.reload('e5573bcc', __exports__)
  }
  
  module.hot.accept("./component-kod-okved.vue?vue&type=template&id=e5573bcc", () => {
    api.rerender('e5573bcc', render)
  })

}


export default __exports__